import styled from "styled-components";

export const LinkText = styled.div`
  text-decoration: underline;
  color: ${(props) => props.theme.colors.textLinkPrimary};
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.caption1)};
`;

export const MessageWrapper = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  padding-left: ${(props) => (props.isMobile ? props.theme.spacing(4) : props.theme.spacing(5))};
`;

export const StyledText = styled.div`
  flex-wrap: wrap;
  display: flex;
  color: ${(props) => props.theme.colors.textPrimary};
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.subtitle1)};
`;

export const StyledWrapper = styled.div<{ $removePaddingUsedAsMargin?: boolean; isMobile?: boolean }>`
  display: flex;
  align-items: center;
  padding-bottom: 40px;
  padding-top: ${(props) => (props.$removePaddingUsedAsMargin || !props.isMobile ? 0 : props.theme.spacing(10))};
  padding-bottom: ${(props) => (props.$removePaddingUsedAsMargin || props.isMobile ? 0 : props.theme.spacing(10))};
`;
